import styled, { css } from "styled-components";
import { theme } from "../../styles/theme";

export const StyledButton = styled("button")<{
  color?: string;
  $variant?: "primary" | "secondary" | "outline";
  $size?: "default" | "large";
}>`
  font-family: inherit;
  font-size: ${(p) => (p.$size === "large" ? "1.0625rem" : "0.9375rem")};
  font-weight: 600;
  width: 100%;
  border-radius: ${theme.radius.sm};
  padding: ${(p) => (p.$size === "large" ? "14px 28px" : "12px 24px")};
  cursor: pointer;
  margin-top: 0.625rem;
  max-width: ${(p) => (p.$size === "large" ? "220px" : "180px")};
  transition: all 0.2s ease-in-out;
  letter-spacing: 0.01em;

  ${(p) =>
    p.$variant === "outline"
      ? css`
          background: transparent;
          color: ${theme.colors.primary};
          border: 2px solid ${theme.colors.primary};
          box-shadow: none;

          &:hover,
          &:active,
          &:focus {
            background: ${theme.colors.primaryLight};
            color: ${theme.colors.primaryDark};
            border-color: ${theme.colors.primaryDark};
          }
        `
      : p.$variant === "secondary"
      ? css`
          background: ${theme.colors.accent};
          color: ${theme.colors.white};
          border: 2px solid ${theme.colors.accent};
          box-shadow: ${theme.shadows.sm};

          &:hover,
          &:active,
          &:focus {
            background: ${theme.colors.accentHover};
            border-color: ${theme.colors.accentHover};
          }
        `
      : css`
          background: ${p.color || theme.colors.primary};
          color: ${theme.colors.white};
          border: 2px solid ${p.color || theme.colors.primary};
          box-shadow: ${theme.shadows.md};

          &:hover,
          &:active,
          &:focus {
            background: ${theme.colors.primaryDark};
            border-color: ${theme.colors.primaryDark};
            transform: translateY(-1px);
            box-shadow: ${theme.shadows.lg};
          }
        `}
`;
